import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import MinistryPage from "./pages/MinistryPage";
import BooksPage from "./pages/BooksPage";
import ClothierPage from "./pages/ClothierPage";
import ContactPage from "./pages/ContactPage";
import AcademyPage from "./pages/AcademyPage";
import BevsFurniturePage from "./pages/BevsFurniturePage";
import BevsProductDetailPage from "./pages/BevsProductDetailPage";
import BevsAdminPage from "./pages/BevsAdminPage";

const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  const hideChrome = pathname.startsWith('/bevs-admin');
  return (
    <>
      {!hideChrome && <Navigation />}
      <main>{children}</main>
      {!hideChrome && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Chrome>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/ministry" element={<MinistryPage />} />
            <Route path="/books" element={<BooksPage />} />
            <Route path="/clothier" element={<ClothierPage />} />
            <Route path="/academy" element={<AcademyPage />} />
            <Route path="/furniture" element={<BevsFurniturePage />} />
            <Route path="/furniture/product/:id" element={<BevsProductDetailPage />} />
            <Route path="/bevs-admin" element={<BevsAdminPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </Chrome>
      </BrowserRouter>
    </div>
  );
}

export default App;
